var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',[_c('span',{staticClass:"text-success"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }